export const DEFAULT_ACTIVITY_RETURN_URL = "/getclmdetail?cId=";
export const TEMPLATE_QUERY_PARAM = "template";
export const DEFAULT_TEMPLATE_PARAM_VALUE = "default";